export class ContactPersonConstants {
  public static readonly positionMaxLength: number = 255;

  public static readonly translationSalutationNone = '';
  public static readonly translationSalutationMr = 'Herr';
  public static readonly translationSalutationMrs = 'Frau';
  public static readonly translationSalutationCompany = 'Company';
}
